var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Card } from '@philips-internal/oswald-ui-components/lib/components/card/card';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as CancelSVG } from '../../assets/images/icons/cancel.svg';
import { ReactComponent as CheckSVG } from '../../assets/images/icons/check.svg';
import ResultTermCardAPI from './result-term-card-api';
import './result-term-card.css';
let ResultTermCard = class ResultTermCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { onClick, termSeqNr } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        termSeqNr,
                    },
                }));
            }
        };
    }
    renderHeader() {
        const { confirmationDate } = this.props;
        return (React.createElement("div", { className: "c-result-term-card__header" },
            React.createElement("div", { className: "c-result-term-card__header-left" }, ModelService.format('date', confirmationDate))));
    }
    renderContent() {
        const { termName } = this.props;
        return (React.createElement("div", { className: "c-result-term-card__content" }, termName));
    }
    renderFooter() {
        const { status } = this.props;
        const msgStatus = status ? MessageService.translate('results.profile-' + status.toLowerCase()) : '';
        return (React.createElement("div", { className: "c-result-term-card__footer" },
            React.createElement("div", { className: "c-result-cpt-card__footer-left" },
                this.getSvg(),
                '\u00A0',
                msgStatus)));
    }
    getSvg() {
        const { status } = this.props;
        switch (status) {
            case 'I':
                return React.createElement(CancelSVG, { className: `c-result-term-card__color-${this.getColor()}` });
            default:
                return React.createElement(CheckSVG, { className: `c-result-term-card__color-${this.getColor()}` });
        }
    }
    getColor() {
        const { status } = this.props;
        switch (status) {
            case 'I':
                return 'gray';
            case 'A':
                return 'green';
            default:
                return 'green';
        }
    }
    render() {
        return (React.createElement(Card, { width: 12, className: "c-result-term-card", selectionType: SelectionType.SINGLE, uuid: "ca1ebccd-b4aa-4a71-84a0-9dffc2104fb9" },
            React.createElement("div", { className: `c-result-term-card__wrapper c-result-term-card__border-${this.getColor()}`, onClick: () => this.onClick() },
                this.renderContent(),
                this.renderHeader(),
                this.renderFooter())));
    }
};
ResultTermCard.propTypes = {
    confirmationDate: string,
    onClick: eventListener,
    status: string,
    termDescription: string,
    termName: string,
    termSeqNr: number,
};
ResultTermCard = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: ResultTermCardAPI })
], ResultTermCard);
export default ResultTermCard;
//# sourceMappingURL=result-term-card.js.map